<template>
  
  <div>
    <div class="post">
      <div v-if="loading">Loading...</div>
      
      <div v-if="error" class="error">{{ error }}</div>

      <div v-if="post" class="post__content">
        <h1 class="post__title">{{ post.title }}</h1>
        <p class="post__body">{{ post.body }}</p>
      </div>
        
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import axios from 'axios'

export default {
  name: 'post',
  props: ['id'],
  
  data() {
    return {
      param_id: this.$route.params.id,
      loading: false,
      post: null,
      error: null,
      endpoint: 'https://jsonplaceholder.typicode.com/posts/',
    }
  },

  created() {
    this.getPost(this.id)
  },

  watch: {
     '$route'() {
       this.getPost(this.id)
     }
  },

  methods: {
    getPost(id) {
      this.error = this.post = null
      this.loading = true
      axios.get(this.endpoint + id)
           .then(response => {
             this.loading = false
             this.post = response.data 
            })
           .catch(err => {
             this.loading = false
             this.error = err.toString()
            })
    }
  },
}
</script>
